/**
 * Created by RKL on 21/08/2015.
 */
define('ordersShowView',[
  'module',
  'underscore',
  'backbone',
  'jqgridView',
  'dateUtils',
  'urlUtil',
  'app',
  'jquery',
  'settings',
  'template!ordersViewTpl',
  'logotoolUtils',
  'datePickerPopoverMixin',
  'jqgridActionsButtonFormatterActions',
  'jqgridActionsButtonFormatterView',
  'bootbox',
  'orderUtils',
  'entities/orders'

], function (
  module,
  _,
  Backbone,
  JqGridView,
  dateConverter,
  UrlUtil,
  App,
  $,
  Settings,
  viewTpl,
  logotoolUtils,
  datePickerPopoverMixin,
  availableActions,
  ActionButtonsView,
  bootbox,
  OrderUtils
) {
  'use strict';

  var OrdersView = JqGridView.extend({
    template: viewTpl,
    filtersName: 'ordersFilters',

    regions: {
      ordersActions: '.js-action-buttons-region'
    },

    onShow: function () {
      $.material.init();
      this.updateExportUrl({});
      this.createActionButtonView();
    },

    ui: function () {
      return _.extend({
        jqGrid: '#jq-grid-list',
        jqGridPager: '#jq-grid-pager-list',
        downloadPdf: '.orders-pdf-download',
        payedByCustomerCheckbox: '.js-ticket-payed-by-customer[type=checkbox]',
        payedToManufacturerCheckbox: '.js-ticket-payed-to-manufacturer[type=checkbox]'
      }, this.gridUi);
    },

    events: function () {
      return _.extend({
        'change @ui.payedByCustomerCheckbox': 'onPayedByCustomerCheckbox',
        'change @ui.payedToManufacturerCheckbox': 'onPayedToManufacturerCheckbox',
        'mouseover': 'onContextMenuSelected',
        'reloadData': 'reloadData'
      }, this.gridEvents);
    },

    reloadData: function () {
      this.selectedOrders = [];
      this.ui.jqGrid.resetSelection();
      this.updatePagination('reloadGrid');
    },

    onPayedByCustomerCheckbox: function (e) {
      var that = this,
        $input = $(e.currentTarget),
        orderId = $input.data('order-cid'),
        checked = $input.is(':checked');

      that.trigger('order:update', {purchaseOrderId: orderId, payedByCustomer: checked});
    },

    onPayedToManufacturerCheckbox: function (e) {
      var that = this,
        $input = $(e.currentTarget),
        orderId = $input.data('order-cid'),
        checked = $input.is(':checked');

      that.trigger('order:update', {purchaseOrderId: orderId, payedToManufacturer: checked});
    },

    onContextMenuSelected: function (e) {
      e.preventDefault();
      var newRecordId = this.$el.find(e.target).attr('data-row-id');
      if (newRecordId) {
        this.currentRecordId = newRecordId;
        this.currentOrderPaid = this.$el.find(e.target).attr('data-paid') === '1';
        if (this.currentRecordId && !isNaN(this.currentRecordId)) {
          $.contextMenu('destroy');
          OrderUtils._initListContextMenu(this);
        }
      } else {
        $.contextMenu('destroy');
      }
    },

    serializeData: function () {
      this.selectedOrders = Settings.get('selectedOrders') || [];
      var templateData = {
        'type': 'orders'
      };
      if (this.options.endUserSecId) {
        templateData.newOrderLogotoolUrl = logotoolUtils.getLogotoolCataloguesUrl({
          endUserSecId: this.options.endUserSecId,
          returnUrl: UrlUtil.addPathParam('orders')
        });
      } else {
        templateData.newOrderLogotoolUrl = logotoolUtils.getLogotoolCataloguesUrl({
          returnUrl: window.location.href,
          endUserSecId: 'new'
        });
      }
      return templateData;
    },

    gridOptions: function (data) {

      function displayCommentInToolTip(cellValue, rowObject) {
        if (rowObject.comments && rowObject.comments.length > 0 && rowObject.comments[0].content) {
          return ' title="' + cellValue.replace(/<(?:.|\n)*?>/gm, '') + ' \n' +
            _.i18n('common.comment') + ': ' + rowObject.comments[0].content.replaceAll('"', '\'') + '"';
        } else {
          return ' title="' + cellValue.replace(/<(?:.|\n)*?>/gm, '') + '"';
        }
      }

      var that = this,
        defaultsOptions = this.gridInitOptions(data),
        options = {
          colModel: [],

          rowattr: function () {
            return {'class': 'context-menu'};
          },

          serializeGridData: function (postData) {
            if (postData.status === that.selectDefault) {
              delete postData.status;
            }

            if (postData.createDate) {
              postData.dateFrom = datePickerPopoverMixin.parseDateFrom(postData.createDate);
              postData.dateTo = datePickerPopoverMixin.parseDateTo(postData.createDate);
            } else if (!that.sorting) {
              delete postData.dateFrom;
              delete postData.dateTo;
            }
            that.sorting = false;
            defaultsOptions.serializeGridData.apply(this, arguments);


            return postData;
          },

          beforeProcessing: function (data) {
            _.each(data, function (dataRow) {
              if (!dataRow.toInvoice) {
                dataRow.toInvoice = 'false';
              } else if (dataRow.toInvoice && !dataRow.invoiceFileUid) {
                dataRow.toInvoice = 'true';
              } else if (dataRow.toInvoice && dataRow.invoiceFileUid) {
                dataRow.toInvoice = dataRow.invoiceFileUid;
              }

            });
          },

          dateFormatter: function (cellvalue) {
            var date = dateConverter.toDateFormatString(cellvalue),
              time = dateConverter.toTimeFormatString(cellvalue);

            return '<span class="cell-date">' + date + ' ' + time + '</span>';
          },

          gridComplete: function () {
            var supplierNameSearchField = that.$el.find('[name="productOwner"]');
            supplierNameSearchField.css('border-bottom', '1px solid lightgrey');
            supplierNameSearchField.attr('placeholder', _.i18n('offerList.productOwner'));
            var supplierNumberSearchField = that.$el.find('[name="supplierNumber"]');
            if (supplierNumberSearchField && supplierNumberSearchField.length < 2) {
              supplierNumberSearchField.attr('placeholder', _.i18n('orders.supplierNumber'));
              supplierNameSearchField.after(supplierNumberSearchField.parent().html());
            }
            var actionRequireField = that.$el.find('[name="actionRequired"]');

            var isLastMessageFromCustomerField = that.$el.find('[name="isLastMessageByCustomer"]');
            if (isLastMessageFromCustomerField && isLastMessageFromCustomerField.length < 2) {
              actionRequireField.after(isLastMessageFromCustomerField.parent().html());
            }
            var purchaseOrderId = UrlUtil.parseQueryString().purchaseOrderId;
            if (purchaseOrderId) {
              UrlUtil.clearQueryString();
              that.preselectFirstRow();
            }
            defaultsOptions.gridComplete.apply(this, arguments);
            that.checkOrdersSelection();
          },

          beforeSelectRow: function (rowid, event) {
            // check if order selection
            var shouldDownloadFile = $(event.target).hasClass('mdi-file-folder');
            if (shouldDownloadFile) {
              return false;
            }
            var grid = $(this);
            if (event.ctrlKey || event.altKey) {  // alt instead ctrl for mac os
              that.manageCtrlKey(grid, rowid);
            } else if (event.shiftKey) {
              that.manageShiftKey(grid, rowid);
            } else {
              return true;
            }
            return false;
          },

          onSelectRow: function (rowId, bool, e) {
            var cellUpdated = that.$('.cell-payedToManufacturer, .cell-payedByCustomer');
            if ($(e.target).hasClass('js-show-customer-messages')) {
              App.navigate('#orders/' + rowId + '/customer_messages', {trigger: true});
            } else if ($(e.target).hasClass('js-show-internal-messages')) {
              App.navigate('#orders/' + rowId + '/internal_messages', {trigger: true});
            } else if (e && e.type === 'click' && cellUpdated.has(e.target).length === 0 &&
              (App.getCurrentRoute().lastIndexOf('orders') - App.getCurrentRoute().length) === -6) {
              var route = App.getCurrentRoute() === 'orders' ? App.getCurrentRoute() : 'orders/' + App.getCurrentRoute();

              App.navigate(route + '/' + rowId, {trigger: true});
            }
          }
        };

      options.colModel.push({
        label: ' ',
        name: 'snapshotsUids',
        align: 'left',
        classes: 'context-menu order-link image-cell',
        formatter: this.pictureUidFormatter,
        width: 80,
        search: false
      });
      options.colModel.push({
        label: _.i18n('orderList.payedByCustomer'),
        name: 'payedByCustomer',
        classes: 'context-menu order-link cell-payedByCustomer',
        cellEdit: true,
        formatter: this.payedByCustomerFormatter,
        search: true,
        index: 'payedByCustomer',
        stype: 'select',
        searchrules: {select: true},
        searchoptions: {
          value: ':' + _.i18n('common.all') + ';' + true + ':' + _.i18n('common.yes') + ';' + false + ':' + _.i18n('common.no')
        },
        width: 60
      });
      options.colModel.push({
        label: _.i18n('orderList.payedToManufacturer'),
        name: 'payedToManufacturer',
        cellEdit: true,
        classes: 'context-menu order-link cell-payedToManufacturer',
        formatter: this.payedToManufacturerFormatter,
        search: true,
        index: 'payedToManufacturer',
        stype: 'select',
        searchrules: {select: ''},
        searchoptions: {
          value: ':' + _.i18n('common.all') + ';' + true + ':' + _.i18n('common.yes') + ';' + false + ':' + _.i18n('common.no')
        },
        width: 60
      });
      options.colModel.push({
        label: _.i18n('orderList.orderNumber'),
        name: 'purchaseOrderId',
        classes: 'context-menu order-link',
        formatter: this.orderNumberFormatter,
        search: true,
        index: 'purchaseOrderId',
        key: true,
        cellattr: function (rowId, cellValue, rowObject) {
          return displayCommentInToolTip(cellValue, rowObject);
        }
      });
      options.colModel.push({
        label: _.i18n('orderList.endUser'),
        name: 'endUserId',
        classes: 'context-menu order-link',
        formatter: this.defaultFormatter,
        search: true,
        index: 'endUserId',
        cellattr: function (rowId, cellValue, rowObject) {
          return displayCommentInToolTip(cellValue, rowObject);
        }
      });
      options.colModel.push({
        label: _.i18n('orderList.orderCreatDate'),
        name: 'createDate',
        classes: 'context-menu order-link',
        formatter: this.dateFormatter,
        search: true,
        index: 'createDate',
        sorttype: 'date',
        searchrules: {date: true},
        searchoptions: {
          dataInit: datePickerPopoverMixin.jqGridDataInit
        },
        width: 100,
        cellattr: function (rowId, cellValue, rowObject) {
          return displayCommentInToolTip(cellValue, rowObject);
        }
      });
      options.colModel.push({
        label: _.i18n('orderList.productOwner'),
        name: 'productOwner',
        classes: 'context-menu order-link',
        formatter: this.supplierPimFormatter,
        search: true,
        index: 'productOwner',
        cellattr: function (rowId, cellValue, rowObject) {
          return displayCommentInToolTip(cellValue, rowObject);
        }
      });
      options.colModel.push({
        label: _.i18n('orderList.productCode'),
        name: 'productBaseCode',
        classes: 'context-menu order-link',
        formatter: this.defaultFormatter,
        search: true,
        index: 'productCode',
        width: 100,
        cellattr: function (rowId, cellValue, rowObject) {
          return displayCommentInToolTip(cellValue, rowObject);
        }
      });
      options.colModel.push({
        label: _.i18n('orderList.productName'),
        name: 'productName',
        classes: 'context-menu order-link',
        formatter: this.defaultFormatter,
        search: true,
        sortable: false,
        index: 'productName',
        cellattr: function (rowId, cellValue, rowObject) {
          return displayCommentInToolTip(cellValue, rowObject);
        }
      });
      options.colModel.push({
        label: _.i18n('common.quantity'),
        name: 'quantity',
        classes: 'context-menu order-link',
        formatter: this.defaultFormatter,
        search: true,
        sortable: false,
        width: 60,
        index: 'quantity',
        cellattr: function (rowId, cellValue, rowObject) {
          return displayCommentInToolTip(cellValue, rowObject);
        }
      });
      options.colModel.push({
        label: _.i18n('orderList.status'),
        name: 'status',
        classes: 'context-menu order-link',
        search: true,
        index: 'status',
        formatter: this.commandTypeFormatter,
        stype: 'select',
        searchrules: {select: true},
        searchoptions: {
          value: data.statuses,
          defaultValue: that.selectDefault
        },
        cellattr: function (rowId, cellValue, rowObject) {
          return displayCommentInToolTip(cellValue, rowObject);
        }
      });
      options.colModel.push({
        label: _.i18n('orderList.invoiceNumber'),
        name: 'invoiceNumber',
        search: true,
        classes: 'context-menu order-link',
        index: 'invoiceNumber',
        sortable: false,
        formatter: this.invoiceFormatter,
        align: 'center',
        cellattr: function (rowId, cellValue, rowObject) {
          return displayCommentInToolTip(cellValue, rowObject);
        },
        width: 60
      });
      options.colModel.push({
        label: '<i class="mdi-editor-mode-comment" ' +
          'title="' + _.i18n('offerList.actionRequiredInternal') + '"></i>',
        name: 'actionRequiredInternal',
        search: true,
        classes: '',
        index: 'actionRequiredInternal',
        sortable: false,
        formatter: this.actionRequiredFormatter,
        stype: 'select',
        searchrules: {select: ''},
        searchoptions: {
          value: ':' + _.i18n('common.all') + ';' + true + ':' + _.i18n('common.yes') + ';' + false + ':' + _.i18n('common.no')
        },
        align: 'left',
        width: 60
      });
      options.colModel.push({
        label: '<i class="mdi-image-color-lens" ' +
          'title="' + _.i18n('offerList.actionRequiredUkr') + '"></i>',
        name: 'actionRequiredUkr',
        width: 60,
        search: true,
        classes: '',
        index: 'actionRequiredUkr',
        sortable: false,
        formatter: this.actionRequiredFormatter,
        stype: 'select',
        searchrules: {select: ''},
        searchoptions: {
          value: ':' + _.i18n('common.all') + ';' + true + ':' + _.i18n('common.yes') + ';' + false + ':' + _.i18n('common.no')
        },
        align: 'left'
      });
      /*
      options.colModel.push({
        label: _.i18n('offerList.supplierNumber'),
        name: 'supplierNumber',
        width: 110,
        search: true,
        classes: 'hide-column',
        index: 'supplierNumber',
        sortable: false,
        formatter: this.defaultFormatter,
        align: 'left',
        hidden: true,
        searchoptions: {
          attr: {placeholder: _.i18n('offerList.supplierNumber')}
        }
      });
      options.colModel.push({
        label: 'customer last message',
        name: 'isLastMessageByCustomer',
        width: 110,
        search: true,
        classes: 'hide-column',
        index: 'isLastMessageByCustomer',
        sortable: false,
        formatter: this.defaultFormatter,
        align: 'left',
        hidden: true,
        stype: 'select',
        searchoptions: {
          value: ':' + _.i18n('common.all') + ';' + true + ':' + _.i18n('offerList.lastMessageIsFromCustomer')
        }
      });
      */

      options = _.defaults(options, defaultsOptions);

      return options;

    },

    /*
     * orders selection with ctrl/shift keys
    */

    manageCtrlKey: function (grid, rowid) {
      var maxSelectedOrdersNumber = 100,
        $row = grid.find('#' + rowid);
      if ($row.hasClass('selected')) {
        $row.removeClass('selected');
        this.onRowMultiselect(rowid, false);
      } else {
        if (this.selectedOrders.length === maxSelectedOrdersNumber) {
          this.showWarningSelectedNumberOutOfRange();
        } else {
          $row.addClass('selected');
          this.onRowMultiselect(rowid, true);
        }
      }
    },

    manageShiftKey: function (grid, rowid) {
      var firstSelectedOrder = this.getFirstSelectedOrder(),
        lastSelectedRow = grid.find('#' + rowid),
        gridRows = grid.find('tr'),
        lastIndex = gridRows.index(lastSelectedRow),
        lastSelectedOrder = {
          rowid: rowid,
          page: this.pagination.currentPage,
          index: lastIndex
        };

      if (!firstSelectedOrder) firstSelectedOrder = lastSelectedOrder;
      if (firstSelectedOrder.page > lastSelectedOrder.page) {
        this.swapOrders(firstSelectedOrder, lastSelectedOrder);
      } else if (firstSelectedOrder.page === lastSelectedOrder.page) {
        if (firstSelectedOrder.index > lastSelectedOrder.index) {
          this.swapOrders(firstSelectedOrder, lastSelectedOrder);
        }
      }
      if (this.checkIfOnlyCurrentPageSelection(firstSelectedOrder, lastSelectedOrder)) {
        this.selectWithoutRequest(firstSelectedOrder, lastSelectedOrder);
      } else {
        this.getCollectionToPage(firstSelectedOrder, lastSelectedOrder);
      }
    },

    checkIfOnlyCurrentPageSelection: function (first, last) {
      return first.page === last.page;
    },

    selectWithoutRequest: function (first, last) {
      var grid = this.ui.jqGrid,
        list = grid.find('tr');

      this.selectedOrders = [];
      list.each(_.bind(function (index, row) {
        var $row = $(row),
          rowid = $row.attr('id');
        if (index >= first.index &&
          index <= last.index) {
          this.selectedOrders.push({
            rowid: rowid,
            page: this.pagination.currentPage,
            index: index
          });
        }
      }, this));
      this.checkOrdersSelection();
    },

    swapOrders: function (first, last) {
      for (var key in last) {
        var temp = first[key];
        first[key] = last[key];
        last[key] = temp;
      }
    },

    getFirstSelectedOrder: function () {
      var firstSelected,
        lastPage = this.getLastPage(),
        firstIndex = this.pagination.pageSize;
      if (this.selectedOrders.length === 0) {
        return null;
      } else {
        _.each(this.selectedOrders, function (order) {
          if (order.page < lastPage) {
            lastPage = order.page;
            firstIndex = order.index;
            firstSelected = order;
          } else if (order.page === lastPage) {
            if (order.index < firstIndex) {
              firstSelected = order;
              firstIndex = order.index;
            }
          }
        });
        return firstSelected;
      }
    },

    getLastPage: function () {
      var lastPage;
      if (this.selectedOrders.length > 0) {
        lastPage = _.max(this.selectedOrders, function (order) {
          return order.page;
        }).page;
      } else {
        lastPage = this.pagination.currentPage;
      }
      return lastPage;
    },

    getCollectionToPage: function (first, last) {
      var firstOrderIndex = (first.page - 1) * this.pagination.pageSize + (first.index - 1),
        lastOrderIndex = (last.page - 1) * this.pagination.pageSize + last.index,
        size = lastOrderIndex - firstOrderIndex || 1,
        params = {
          pageSize: size,
          first: firstOrderIndex,
          _search: false,
          nd: new Date().getTime(),
          rows: size,
          page: 1,
          sord: 'asc'
        };
      if (size > 100) {
        this.showWarningSelectedNumberOutOfRange();
      } else {
        $('#content-blinder').show();
        this.trigger('onLoadSelectedOrders', first, last, params);
      }
    },

    showWarningSelectedNumberOutOfRange: function () {
      bootbox.alert(_.i18n('common.errorOccuredSelectedItemsNumberOutOfRange'), function () {
        return;
      });
    },

    onSelectOrders: function (first, last, orders) {
      var pageSize = this.pagination.pageSize,
        page, orderIndex;

      this.selectedOrders = [];
      _.each(orders, _.bind(function (order, index) {
        page = Math.floor((index + first.index - 1) / pageSize);
        orderIndex = index + first.index - page * pageSize;
        this.selectedOrders.push({
          rowid: order,
          page: page + first.page,
          index: orderIndex
        });
      }, this));
      this.checkOrdersSelection();
    },

    onRowMultiselect: function (rowid, select) {
      var index,
        grid = this.ui.jqGrid,
        gridList = grid.find('tr'),
        row = grid.find('#' + rowid),
        order = {
          rowid: rowid,
          page: this.pagination.currentPage,
          index: gridList.index(row)
        };
      if (select) {
        this.selectedOrders.push(order);
      } else {
        index = this.selectedOrders.indexOf(_.findWhere(this.selectedOrders, {rowid: rowid}));
        this.selectedOrders.splice(index, 1);
      }
      this.onSelectedOrdersChanged();
    },

    createActionButtonView: function () {
      this.actionsButtonView = this._getActionButtonsView();
      this.listenTo(this.actionsButtonView, 'action', this._onAction);
      this.getRegion('ordersActions').show(this.actionsButtonView);
      this.actionsButtonView.setButtonsState({
        'proofsheet': false,
        'export': false
      });
    },

    _getActionButtonsView: function () {
      var actions = ['proofsheet', 'export'],
        actionsCollection = new Backbone.Collection();
      _.each(actions, function (action) {
        actionsCollection.push(availableActions[action]);
      });

      return new ActionButtonsView({
        collection: actionsCollection,
        dontShowIcons: true
      });
    },

    _onAction: function (action) {
      switch (action) {
        case 'proofsheet':
          this.downloadProofsheets();
          break;
        case 'export':
          this.exportOrders();
          break;
        default :
          throw 'Action is not supported';
      }
    },

    checkOrdersSelection: function () {
      var $list = this.ui.jqGrid.find('tr');
      $list.each(_.bind(function (index, item) {
        var $item = $(item);
        if (_.some(this.selectedOrders, {rowid: $item.attr('id')})) {
          $item.addClass('selected');
        } else {
          $item.removeClass('selected');
        }
      }, this));
      this.onSelectedOrdersChanged();
    },

    onSelectedOrdersChanged: function () {
      if (this.selectedOrders.length > 0) {
        this.actionsButtonView.setButtonsState({
          'proofsheet': true,
          'export': true
        });
      } else {
        this.actionsButtonView.setButtonsState({
          'proofsheet': false,
          'export': false
        });
      }
      Settings.set('selectedOrders', this.selectedOrders);
    },

    downloadProofsheets: function () {
      this.downloadPdf('prf');
    },

    exportOrders: function () {
      this.downloadPdf('pzi');
    },

    downloadPdf: function (docType) {
      var orders = [];
      _.each(this.selectedOrders, function (order) {
        orders.push(order.rowid);
      });
      window.open(App.request('order:get-pdf-url', {
        docType: docType,
        poi: orders
      }));
    },

    supplierPimFormatter: function (cellValue, options, model) {
      if (cellValue === null || cellValue === undefined) {
        cellValue = '';
      }

      if (model.pim) {
        return '<div class="col-left name-holder pim-icon m-l-0" style="height: 18px; ' +
          'text-orientation: unset; writing-mode: unset; letter-spacing: unset;">' +
          '    <label>PIM</label>\n' +
          '</div><span class="cell-default" data-row-id="' +
          options.rowId + '" data-paid="' + (model.payedByCustomer ? '1' : '0') + '">' + cellValue + '</span>';
      } else {
        return '<span class="cell-default" data-row-id="' +
          options.rowId + '" data-paid="' + (model.payedByCustomer ? '1' : '0') + '">' + cellValue + '</span>';
      }
    },

    personalizedFormatter: function (cellvalue, options, rowObj) {
      var checked = rowObj.personalized ? 'checked' : '',
        htmlEl = '<div class="m-l-15">' +
          '<input disabled="disabled" type="checkbox" data-ticket-cid="' + options.rowId +
          '" class="cpz-checkbox js-ticket-urgent" ' + checked + ' ' +
          '></div>';
      return htmlEl;
    },

    payedByCustomerFormatter: function (cellValue, options, rowObj) {
      var checked = rowObj.payedByCustomer ? 'checked' : '',
        htmlEl = '<div class="m-l-15">' +
          '<input  type="checkbox" data-order-cid="' + options.rowId +
          '" class="cpz-checkbox js-ticket-payed-by-customer" ' + checked + ' ' +
          '></div>';
      return htmlEl;
    },

    payedToManufacturerFormatter: function (cellValue, options, rowObj) {
      var checked = rowObj.payedToManufacturer ? 'checked' : '',
        htmlEl = '<div class="m-l-15">' +
          '<input type="checkbox" data-order-cid="' + options.rowId +
          '" class="cpz-checkbox js-ticket-payed-to-manufacturer" ' + checked + ' ' +
          '></div>';
      return htmlEl;
    },

    orderNumberFormatter: function (cellvalue, options, model) {
      return '<span class="cell-default jqgridContextMenuCell" data-row-id="' + cellvalue +
        '" data-paid="' + (model.payedByCustomer ? '1' : '0') + '">' + cellvalue + '</span>';
    },

    commandTypeFormatter: function (cellValue, options, model) {
      if (cellValue === null || cellValue === undefined) {
        cellValue = '';
      }

      var statuses = [], statusValue;

      if (options.colModel.searchoptions.value) {
        statuses = options.colModel.searchoptions.value.split(';');
      }

      _.each(statuses, function (status) {
        var st = status.split(':');
        if (st.length === 2) {
          if (st[0] === cellValue) {
            statusValue = st[1];
          }
        }
      });

      if (!statusValue) {
        statusValue = _.i18n('commandstatus.' + cellValue.toLowerCase());
      }

      return '<span class="cell-default" data-row-id="' +
        options.rowId + '" data-paid="' + (model.payedByCustomer ? '1' : '0') + '">' + statusValue + '</span>';
    },

    invoiceFormatter: function (cellvalue, options, rowObject) {
      var insertHTML, fileClass, toInvoice = rowObject.toInvoice,
        url = Settings.url('file', toInvoice, {cmds: 'on'});


      if (toInvoice === 'false') {
        insertHTML = '';
      } else if (toInvoice === 'true') {
        insertHTML = '';
        fileClass = 'mdi-file-folder-open';
      } else {
        if (toInvoice.indexOf(',') !== -1) {
          url = '#orders/' + rowObject.purchaseOrderId + '/order_invoices';
        }
        insertHTML = '<a href="' +
          url +
          '"><i class="mdi-file-folder" title="Invoice Number ' + ((cellvalue) ? cellvalue : '') + '" aria-hidden="true"></i></a>';
      }

      var htmlEl = '<div class="' + fileClass + '">' + insertHTML + '</div>';
      return htmlEl;
    },
    actionRequiredFormatter: function (cellvalue, options) {
      var insertHTML, actionHTML;
      switch (options.colModel.name) {
        case 'actionRequired':
          actionHTML = 'class="mdi-action-markunread-mailbox js-show-customer-messages" title="' +
            _.i18n('offerList.actionRequired') + '"';
          break;
        case 'actionRequiredInternal':
          actionHTML = 'class="mdi-editor-mode-comment js-show-internal-messages" title="' +
            _.i18n('offerList.actionRequiredInternal') + '"';
          break;
        case 'actionRequiredUkr':
          actionHTML = 'class="mdi-image-color-lens js-show-internal-messages" title="' +
            _.i18n('offerList.actionRequiredUkr') + '"';
          break;
      }

      if (cellvalue === false) {
        insertHTML = '';
      } else if (cellvalue === true) {
        insertHTML = '<i ' + actionHTML + ' aria-hidden="true">';
      }

      var htmlEl = '<div>' + insertHTML + '</div>';
      return htmlEl;
    },
    updateExportUrl: function (data) {
      this.$el.find('.orders-export').attr('href', App.request('order:get-excel-url', data));
    },
    onGridFilterChange: function () {
      var that = this,
        filters = {},
        value;

      _.each(this.colModel, function (column) {
        if (column.search) {
          if (column.stype === 'select') {
            value = that.$('select[name="' + column.index + '"]').val();
            filters[column.index] = value === that.selectDefault ? '' : value;
          } else if (column.sorttype === 'date') {
            value = that.$('input[name="' + column.index + '"]').val();
            if (column.index === 'createDate' && value) {
              filters.dateFrom = datePickerPopoverMixin.parseDateFrom(value);
              filters.dateTo = datePickerPopoverMixin.parseDateTo(value);
            }
          } else {
            value = that.$('input[name="' + column.index + '"]').val();
            filters[column.index] = value;
          }
        }
      });

      this.filters = filters;
      this.filterChange = true;
      this.updatePagination(true);
      this.updateExportUrl(filters);
    }
  });

  module.exports = OrdersView;
});

